function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { defineComponent, h } from '@vue/composition-api';
import Icon, { IconProps } from './Icon';
/**
 * 帮助快速生成自定义Icon组件
 */

var generateIcon = function generateIcon(svg, options) {
  return defineComponent({
    name: options === null || options === void 0 ? void 0 : options.name,
    props: IconProps,
    emits: ['click'],
    setup: function setup(props, context) {
      return function () {
        return h(Icon, {
          "props": _objectSpread({}, props),
          "attrs": {
            "svg": svg
          },
          "on": {
            "click": function click(e) {
              return context.emit('click', e);
            }
          }
        });
      };
    }
  });
};

export default generateIcon;